export function createStyleSheetLayer(name = '', sheetConstructor, getPreviousSheet) {
    return {
        sheet: new sheetConstructor(getPreviousSheet, name),
        order: [],
        layers: {},
        name
    };
}
export function flushStyleSheetLayer(sheets) {
    sheets.sheet.flush();
    sheets.order.forEach((segment)=>flushStyleSheetLayer(sheets.layers[segment]));
}
/**
 * Recursively finds the last sheet for a specific layer.
 */ function getLastStyleSheetLayer(parentLayer, segment) {
    const sheetLayer = segment && parentLayer.layers[segment];
    if (!sheetLayer) {
        return parentLayer;
    }
    const lastSegment = sheetLayer.order[sheetLayer.order.length - 1];
    return getLastStyleSheetLayer(sheetLayer, lastSegment);
}
export function getStyleSheetLayer(parentLayer, segment, sheetConstructor, frozen) {
    if (parentLayer.layers[segment]) {
        return parentLayer.layers[segment];
    }
    const name = parentLayer.name ? `${parentLayer.name}.${segment}` : segment;
    if (frozen) {
        throw new Error(`Cannot create a stylesheet "${name}" after stylesheets have been frozen.`);
    }
    const lastSegment = parentLayer.order[parentLayer.order.length - 1];
    const getPreviousSheet = ()=>getLastStyleSheetLayer(parentLayer, lastSegment).sheet;
    const segmentSheets = createStyleSheetLayer(name, sheetConstructor, getPreviousSheet);
    parentLayer.layers[segment] = segmentSheets;
    parentLayer.order.push(segment);
    return segmentSheets;
}
export function walkStyleSheetLayer(layer, callback) {
    // NOTE: To align with the cascade layer spec, we should shift this to occur
    // after the loop (and update the insertion order of the <style> elements to
    // match as well).
    callback(layer);
    for(let i = 0; i < layer.order.length; i++){
        const segment = layer.order[i];
        walkStyleSheetLayer(layer.layers[segment], callback);
    }
}

//# sourceMappingURL=StyleSheetLayer.js.map